import { Component, OnInit } from '@angular/core';

import {
    KeyRateIndicator,
    KeyRateIndicatorsResponse,
} from 'TargetRatesApp/interfaces/target-rates-endpoints.interfaces';

import { TargetRatesService } from 'TargetRatesApp/services/target-rates.service';

@Component({ standalone: false, selector: 'ycn-key-rates', templateUrl: './key-rates.template.html' })
export class KeyRatesComponent implements OnInit {
    indicesTabs: string[] = ['Core Treasury Yields', 'Credit Rates Yields'];

    activeSubtab: string = this.indicesTabs[0];

    DailyTreasuryYieldCurveRatesIndicators: KeyRateIndicator[] = [];

    BankOfAmericaMerrillLynchIndicators: KeyRateIndicator[] = [];

    constructor(private targetRatesService: TargetRatesService) {}

    ngOnInit(): void {
        this.targetRatesService.getKeyRatesIndicators().subscribe((response: KeyRateIndicatorsResponse) => {
            this.DailyTreasuryYieldCurveRatesIndicators = response.daily_treasury_yield_curve_rates;
            this.BankOfAmericaMerrillLynchIndicators = response.bank_of_america_merrill_lynch;
        });
    }

    updateIndex(subtab: string): void {
        this.activeSubtab = subtab;
    }
}
